module.exports = __webpack_public_path__ + "assets/img/report-button-2.ab606bc3.png";